var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00014 10.0001C3.00014 5.858 6.358 2.50014 10.5001 2.50014C14.6423 2.50014 18.0001 5.858 18.0001 10.0001C18.0001 14.1423 14.6423 17.5001 10.5001 17.5001C6.358 17.5001 3.00014 14.1423 3.00014 10.0001ZM10.5001 1.42871C5.76657 1.42871 1.92871 5.26657 1.92871 10.0001C1.92871 14.7337 5.76657 18.5716 10.5001 18.5716C15.2337 18.5716 19.0716 14.7337 19.0716 10.0001C19.0716 5.26657 15.2337 1.42871 10.5001 1.42871ZM12.8216 6.60728C12.8216 7.22296 12.577 7.81343 12.1416 8.24878C11.7063 8.68413 11.1158 8.92871 10.5001 8.92871C9.88446 8.92871 9.29399 8.68413 8.85864 8.24878C8.42329 7.81343 8.17871 7.22296 8.17871 6.60728C8.17871 5.9916 8.42329 5.40114 8.85864 4.96578C9.29399 4.53043 9.88446 4.28585 10.5001 4.28585C11.1158 4.28585 11.7063 4.53043 12.1416 4.96578C12.577 5.40114 12.8216 5.9916 12.8216 6.60728ZM10.5001 15.3573C12.8673 15.3573 14.7859 13.8266 14.7859 11.5309C14.7859 10.6851 14.1001 10.0001 13.2551 10.0001H7.74514C6.89942 10.0001 6.21443 10.6859 6.21443 11.5309C6.21443 13.8266 8.133 15.3573 10.5001 15.3573Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.fca3315b7e299eedb852aae6bb9fe097.svg";
export { ForwardRef as ReactComponent };